import { clsx } from 'clsx'

type InlineCodeProps = React.JSX.IntrinsicElements['code']

export const InlineCode = ({
  children,
  className,
  ...rest
}: InlineCodeProps) => {
  return (
    <code
      {...rest}
      className={clsx(
        className,
        'font-mono bg-dark-border-solid light:bg-dark-shade rounded-md py-px -my-px px-1 inline-block text-dark-dim'
      )}
    >
      {children}
    </code>
  )
}
